module.exports = __webpack_public_path__ + "img/ico02.137658c5.svg";